import { get } from 'lodash';
import { instance } from './api.service';

export const sendEmail = async (email) => {
  const resp = await instance.post(`/email/sendEmail`, { email });
  return get(resp, 'data.email', []);
};
